import {formatPercentage} from "@/app/utils/Format";

export default function(percentage, decimals, context) {
    if (context === undefined) decimals = 1; // this happens when we are invoked with only one arg
    return new Handlebars.SafeString(formatPercentage(percentage, decimals));
}